var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScrollArrowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 30 30",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.065 25.935a1.494 1.494 0 0 1-2.115 0L7.065 16.05a1.494 1.494 0 0 1 0-2.115l9.87-9.87a1.494 1.494 0 0 1 2.115 0c.6.585.6 1.53.015 2.115L10.245 15l8.82 8.82c.585.585.585 1.53 0 2.115z"
})));
export default SvgScrollArrowIcon;